module.exports = __webpack_public_path__ + "static/media/editIcon.716152ff.svg";